import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { RouteSaveDto } from "../../models/route/route";
import { RouteDialog } from "./RouteDialog";
import { getRoute } from "../../services/routeService";

export const RouteDialogWrapper = () => {
    const history = useHistory();
    const { id } = useParams<{ id?: string }>();
    const [route, setRoute] = useState<RouteSaveDto>();

    useEffect(() => {
        let mounted = true;

        const setNew = () =>
            setRoute({
                id: null,
                rowId: null,
                name: "",
                comment: null,
                isActive: true,
            });

        if (!id || id === "new") {
            setNew();
            return () => {
                mounted = false;
            };
        }

        getRoute(id)
            .then((r) => {
                if (!mounted) return;
                if (r) {
                    setRoute({
                        id: r.id ?? null,
                        rowId: r.rowId ?? null,
                        name: r.name ?? "",
                        comment: r.comment ?? null,
                        isActive: r.isActive ?? true,
                    });
                } else {
                    setNew();
                }
            })
            .catch(() => setNew());

        return () => {
            mounted = false;
        };
    }, [id]);

    return <RouteDialog open item={route} onClose={() => history.goBack()} enableIsActive />;
};
